import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FAQ = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "Wat is blauwe lotus thee en wat doet het?",
      answer: "Blauwe lotus thee (Nymphaea caerulea) is een eeuwenoude kruidenthee uit Egypte met natuurlijk kalmerende, licht euforische effecten. Het bevordert ontspanning, levendige dromen en een gevoel van welzijn — perfect voor een bewust avondritueel.",
    },
    {
      question: "Is blauwe lotus gevaarlijk of legaal in Nederland?",
      answer: "Blauwe lotus is 100% legaal in Nederland en de EU en bij normaal gebruik niet gevaarlijk. Het is niet verslavend en heeft geen bekende bijwerkingen bij verantwoord gebruik. Combineer het niet met alcohol, slaapmiddelen of antidepressiva zonder overleg met je arts.",
    },
    {
      question: "Waar kan ik de beste blauwe lotus thee kopen?",
      answer: "Je koopt premium blauwe lotus thee, druppels en tinctuur direct bij Lunssence. Wij leveren biologische, geteste Nymphaea caerulea zonder vulmiddelen — discreet verzonden via PostNL, gratis vanaf €50.",
    },
    {
      question: "Wat is het verschil met de blauwe lotus thee van Holland & Barrett?",
      answer: "Lunssence gebruikt enkel pure Egyptische Nymphaea caerulea bloemen in een hogere concentratie dan veel supermarkt- en drogisterijvarianten. Elke batch wordt getest op zuiverheid, zodat je een sterkere en zuiverdere ervaring krijgt.",
    },
    {
      question: "Is Lunssence veilig en legaal?",
      answer: "Ja, Lunssence is 100% natuurlijk, veilig en volledig legaal in Nederland en Europa. Onze blauwe lotus is van de hoogste kwaliteit en getest op zuiverheid. Het is niet verslavend en heeft geen bekende bijwerkingen bij normaal gebruik.",
    },

    {
      question: "Hoe bereid ik de thee en hoeveel moet ik gebruiken?",
      answer: "Gebruik 1-2 theelepels per kopje. Giet er heet (niet kokend) water van ongeveer 80°C overheen en laat 5-10 minuten trekken. Voor een sterkere werking kun je langer laten trekken. Start met een lagere dosering om je gevoeligheid te testen.",
    },
    {
      question: "Wanneer merk ik de effecten en hoe lang duren ze?",
      answer: "De kalmerende effecten beginnen meestal binnen 15-30 minuten na consumptie. De effecten kunnen 2-4 uur aanhouden. Voor de beste resultaten drink je de thee op een lege maag, bij voorkeur 's avonds voor ontspanning.",
    },
    {
      question: "Kan ik Lunssence combineren met medicijnen?",
      answer: "Hoewel blauwe lotus natuurlijk is, raden we aan om eerst je arts te raadplegen als je medicijnen gebruikt, vooral slaapmiddelen of antidepressiva. Lunssence kan de kalmerende effecten van sommige medicijnen versterken.",
    },
    {
      question: "Hoe wordt Lunssence verzonden en wat zijn de kosten?",
      answer: "We verzenden discreet via PostNL. Gratis verzending vanaf €50. Orders voor 15:00 worden dezelfde dag verzonden. Levertijd is 1-2 werkdagen in Nederland. We leveren ook naar België en Duitsland.",
    },
    {
      question: "Hoe bewaar ik mijn Lunssence thee het beste?",
      answer: "Bewaar de thee op een koele, droge plaats in de originele verpakking. Vermijd direct zonlicht en vocht. Bij juiste opslag blijft de thee tot 2 jaar houdbaar en behoudt het zijn potentie.",
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-muted/20 to-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-6 animate-on-scroll">
            Veelgestelde Vragen
          </h2>
          
          <div className="w-16 h-1 bg-gradient-gold mx-auto mb-8 animate-on-scroll [animation-delay:0.2s]" />
          
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto animate-on-scroll [animation-delay:0.4s]">
            Alles wat je wilt weten over Lunssence blauwe lotus thee
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-4 animate-on-scroll"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div
                className={`accordion-glow ${openFAQ === index ? 'active' : ''} 
                  bg-card rounded-2xl border border-border hover:border-gold/30 transition-all duration-300 overflow-hidden`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-muted/20 transition-colors duration-200"
                >
                  <h3 className="font-serif text-lg font-semibold text-primary pr-4">
                    {faq.question}
                  </h3>
                  <ChevronDown
                    className={`w-6 h-6 text-gold flex-shrink-0 transition-transform duration-300 ${
                      openFAQ === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-8 pb-6">
                    <div className="w-full h-px bg-gradient-gold mb-4 opacity-30" />
                    <p className="text-muted-foreground leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-16 animate-on-scroll [animation-delay:0.8s]">
          <div className="bg-card rounded-2xl p-8 max-w-2xl mx-auto border border-gold/20">
            <h3 className="font-serif text-2xl font-bold text-primary mb-4">
              Nog Vragen?
            </h3>
            <p className="text-muted-foreground mb-6">
              Ons team staat klaar om je te helpen. Stuur ons een bericht en we reageren binnen 24 uur.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="mailto:info@lunssence.com"
                className="inline-flex items-center justify-center btn-hero px-8 py-3 rounded-full font-semibold transition-all duration-300"
              >
                📧 info@lunssence.com
              </a>
              <a
                href="https://wa.me/31619471444"
                className="inline-flex items-center justify-center btn-secondary px-8 py-3 rounded-full font-semibold transition-all duration-300"
              >
                📱 WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};